import React, { useState, useEffect } from 'react';
import { CirclePicker } from 'react-color'
import smallArrowIcon from '#/assets/icons/small-arrow.svg';
import { CSSTransition } from 'react-transition-group';

import { useTranslation } from "react-i18next";

import styles from './styles.module.css';

const colors = [
  '#ff4848', '#ff6a44', '#de973b', '#fcec22', '#b0ef41',
  '#62bf03', '#00d49b', '#ffffff', '#fe5e3a', '#33d9d9', '#479dff', '#bf54f2',
  '#ff5edf', '#ffc107', '#9a9a9a'
];

function Color({ title, borderColor = '#bdbdbd', currentColor, onSelect }) {
  const [displayColorPicker, setDisplayColorPicker] = useState(false);
  const [borderC, setBorderC] = useState(borderColor);
  const [color, setColor] = useState(currentColor ? currentColor : colors[0]);
  const { t } = useTranslation();

  useEffect(() => {
    setColor(currentColor);
    setBorderC(borderColor);
  }, [currentColor, borderColor])

  function handleClick(color) {
    setBorderC('#707070');
    setDisplayColorPicker(true);
  }

  function handleChange(selectedColor) {
    setColor(selectedColor.hex);
    setDisplayColorPicker(false);
    setBorderC(borderColor);
    onSelect(selectedColor.hex);
  }

  function handleClose(color) {
    setBorderC(borderColor);
    setDisplayColorPicker(false);
  }

  return (
    <div>
      <div className={styles.container}>
        {title && title.trim() !== '' ? <label className={styles.title}>{title}</label> : null}
        <div className={styles.swatch} 
          style={{
            borderColor: borderC
          }}
          onClick={handleClick}>
          <div className={styles.color} style={{
            backgroundColor: color
          }} />
          <div style={{ borderColor: borderC }} className={styles.rectangle}>
          <img
            src={smallArrowIcon}
            alt={t('ARROW_MENU_CLOSE_COLORPICKER')}
            className={styles.noSelect}
          />
          </div>
        </div>
      </div>

        <CSSTransition 
          in={displayColorPicker}
          timeout={300} 
          classNames={{
            enter: styles['popover-enter'],
            enterActive: styles['popover-enter-active'],
            exit: styles['popover-exit'],
            exitActive: styles['popover-exit-active']
          }}
          unmountOnExit>
          <div className={styles.popover}>
            <div className={styles.cover} onClick={handleClose}/>
            <CirclePicker color={color} onChange={handleChange} colors={colors}/>
          </div>
        </CSSTransition>
    </div>
  );
}

export default Color;
